import React from "react";
import Refferaltabs from "./tab/RefferalTab";
import "../../assets/scss/refferalpartner.scss";

const RefferalPartner = () => (
  <div className="refferal_tabs row mb-2">
    <div className="col-12">
      <Refferaltabs />
    </div>
  </div>
);

export default RefferalPartner;
